<template>
  <div>
    <v-container fluid>
      <div class="text-h6 white--text d-md-none" style="margin-top: 10px;">Voucher de compra do<br />passaporte</div>
      <div class="text-h6 black--text d-none d-md-block" style="margin-top: 10px;">Voucher de compra do<br />passaporte</div>
    </v-container>
    <v-img src="/img/banner-1.jpg" height="150px" width="100%"></v-img>
    <v-container fluid>
        <div class="text-h5 font-weight-black">Voucher Parque {{ parques[voucher.parque]?.nome }}</div>
        <div class="text-subtitle-2">{{ parques[voucher.parque]?.endereco }}</div>
        <div class="text-subtitle-2 pb-2">{{ parques[voucher.parque]?.telefone }}</div>
        <v-alert text
      prominent
      type="error">Este voucher já foi utilizado</v-alert>
        <v-row>
          <v-col cols="9"><div class="text-h6">Nome</div></v-col>
          <v-col cols="3"><div class="text-h6">ID</div></v-col>
        </v-row>
        <v-row>
          <v-col cols="9"><div class="text-subtitle-1">{{ voucher?.cliente?.nome }}</div></v-col>
          <v-col cols="3"><div class="text-subtitle-1">#{{ voucher?.id }}</div></v-col>
        </v-row>
        <div class="text-h6">Ingressos</div>
        <div v-for="(p, i) of voucher.produtos" :key="i">
          <div class="text-subtitle-1">{{ p.titulo }}</div>
          <div class="text-subtitle-2">{{ p.quantidade }}x {{ p.valorPromo | fmtNumber }} = R$ {{ p.total | fmtNumber }}</div>
        </div>
        <div class="text-h6 text-right">Total: R$ {{ voucher?.valor | fmtNumber }}</div>
    </v-container>
  </div>
</template>
<style scoped>
.card-button {
  background-color: white;
  width: 100%;
  height: 150px !important;
}
</style>
<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['voucher', 'parques'])
  }
}
</script>
